/** @format */

import React, { useEffect, useState } from "react";
import PanToolIcon from "@mui/icons-material/PanTool";
import Tooltip from "@mui/material/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import { handleDragToggleButton } from "../../../../store/reducers/pdfeditor/toolsModificationSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteCoordinate } from "../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import { modifiedCoordinateFunc } from "../../../../store/reducers/pdfeditor/pdfAddedRemovedCoordSlice";
function ToolBarErase({ position, coordinate, setSelectedBoxId }) {
  const dispatch = useDispatch();
  const { eraseToggleButton } = useSelector((state) => state.toolsModification);
  const [enableDraggingErase, setEnableDraggingErase] = useState(false);
  const { coordinates } = useSelector((state) => state.pdfCoordinates);
  const handleDragToggle = () => {
    setEnableDraggingErase((prev) => {
      const newEnableDraggingText = !prev;
      dispatch(handleDragToggleButton(newEnableDraggingText));
      return newEnableDraggingText;
    });
  };

  useEffect(() => {
    setEnableDraggingErase(eraseToggleButton);
  }, [eraseToggleButton]);

  const findRemovedCoord = (id) => {
    const removedCoord = coordinates.find((item) => item.id === id);
    if (removedCoord) {
      dispatch(modifiedCoordinateFunc({ ...removedCoord, action: "removed" }));
    }
  };
  const handleDeleteVariable = (id) => {
    alert("Delete",id);
    dispatch(deleteCoordinate(id));
    findRemovedCoord(id);
  };
  return (
    <div
      style={{
        position: "absolute",
        left: `${position.prex}px`,
        top: `${position.prey - 38}px`,
        zIndex: 4,
      }}
    >
      <div
        style={{
          display: "flex",
          border: "1px solid #1976d2",
          background: "#fff",
          borderRadius: "5px",
          height: "38px",
          boxShadow: "0 0 10px 1px #1976d2",
        }}
      >
        {/* Drag Box */}
        <Tooltip title={`Toggle Drag`} placement='bottom'>
          <PanToolIcon
            onClick={() => setSelectedBoxId(null)}
            // onClick={() => handleDragToggle()}
            sx={{
              borderRadius: enableDraggingErase ? "5px" : "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize:'2rem !important'
            }}
            // fontSize="large"
          />
        </Tooltip>

        <div
          style={{ width: "1px", height: "100%", background: "#1976d2" }}
        ></div>

        {/* *********Delete Box********* */}
        <Tooltip title={`Deletee` } placement='bottom'>
          <DeleteIcon
            onClick={() =>
              handleDeleteVariable(coordinate?.id || coordinate?.variable)
            }
            sx={{
              borderRadius: coordinate?.color ? "5px" : "5px",
              color: "#1976d2",
              padding: "7px",
              background: "white",
              // fontSize: "2rem !important",
            }}
            // fontSize="large"
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default ToolBarErase;
